import React, {useState, useEffect} from "react";
import { TextField } from "@mui/material";
import RelatedDocs from "../modals/RelatedDocs";
import QuotationDocs from "../modals/QuotationDocs";
import axios from "axios";
import { Select, MenuItem, FormControl, InputLabel } from "@mui/material";

const CustomerDetailsTab = ({ selectedLead, subject, setCustomerSubject, customerTRN, setCustomerTRN, setDataEnteredFromCustomerDetailsTab, dataEnteredFromCustomerDetailsTab }) => {
  console.log("selectedLead from customer Details Tab", selectedLead, dataEnteredFromCustomerDetailsTab);

  const currentDepartmentFromLocalStorage = localStorage.getItem("currentSelectedDepartment");
  let company_code_from_local_storage = localStorage.getItem("companyCode") ? localStorage.getItem("companyCode") : "-"
  let apiPaths_from_local_storage = localStorage.getItem("apiPaths") ? JSON.parse(localStorage.getItem("apiPaths")) : "-"
  
  const [salespersonList, setSalesPersonList] = useState(null);
  
  const currentUserObject = JSON.parse(localStorage.getItem("currentUser"));
  const userAccessGroup = currentUserObject[0].accessgrp;
  const [accessgroupFromLocal, setAccessgroupFromLocal] = useState(userAccessGroup)

  const handleTRNChange = (event) => {
    setCustomerTRN(event.target.value);
  };
  const handleSubjectChange = (event) => {
    setCustomerSubject(event.target.value); // Update the TRN value based on user input
  };

  const callSalesPersonListAPI = () => {
    const apiUrl = `${apiPaths_from_local_storage[0].API_CONFIG}/api/MasterCount/${company_code_from_local_storage}/SALESPERSONLIST/-/${currentDepartmentFromLocalStorage}`;
    axios
      .get(apiUrl)
      .then((res) => {
        setSalesPersonList(res.data);
      })
      .catch((err) => { });
  };
  
  useEffect(() => {
    callSalesPersonListAPI();
  }, []);

  const handleChangeSalesPerson = (e)=>{

    console.log("e sales person ", e)

    setDataEnteredFromCustomerDetailsTab((prev) => ({ ...prev, sales_person_id_from_tab: e.target.value }))

  }

  return (
    <div>
      <div className="grid grid-cols-5 gap-4 mb-4">
        {/* <TextField
        label="Lead ID"
        size="small"
        variant="standard"
        value={selectedLead?.lead_id}
      /> */}
        {/* <p> Lead {selectedLead?.lead_id}</p> */}
        <TextField
          label="Attention Person Info"
          size="small"
          variant="standard"
          onChange={(e) => setDataEnteredFromCustomerDetailsTab((prev) => ({ ...prev, contact_person_from_tab: e.target.value }))}
          value={dataEnteredFromCustomerDetailsTab?.contact_person_from_tab}
        />
        <TextField
          label="Phone number"
          size="small"
          variant="standard"
          onChange={(e) => setDataEnteredFromCustomerDetailsTab((prev) => ({ ...prev, contact_phone_number_from_tab: e.target.value }))}
          value={dataEnteredFromCustomerDetailsTab?.contact_phone_number_from_tab}
        />

        <TextField
          label="Email"
          size="small"
          variant="standard"
          onChange={(e) => setDataEnteredFromCustomerDetailsTab((prev) => ({ ...prev, contact_person_email_from_tab: e.target.value }))}
          value={dataEnteredFromCustomerDetailsTab?.contact_person_email_from_tab}
        />



        <div className="mb-0">
          <TextField
            disabled={accessgroupFromLocal != "ADMIN" && accessgroupFromLocal != "COORDINATOR"}
            select
            label="Sales Person"
            name="salesperson"
            value={dataEnteredFromCustomerDetailsTab?.sales_person_id_from_tab}
            onChange={handleChangeSalesPerson}
            fullWidth
            required
            variant="standard"
            id="standard"
            error={!dataEnteredFromCustomerDetailsTab?.sales_person_id_from_tab}
            sx={{
              "& .MuiInputLabel-root": {
                fontFamily: "Figtree, sans-serif", // Force Figtree font for label
              },
              "& .MuiInputBase-input:focus": {
                boxShadow: "none !important", // Removes any shadow applied
              },
            }}
          >
            <MenuItem value="" disabled>
              Select Sales Person
            </MenuItem>

            {salespersonList?.map((item) => {
              return <MenuItem value={item.EMP_ID?.trim()}>{item.NAME}</MenuItem>;
            })}
          </TextField>
        </div>

        {/* <TextField
          label="Customer Reference Number"
          value="32053"
          size="small"
          variant="standard"
        />
        <TextField
          label="Subject"
          size="small"
          variant="standard"
          value={subject}
          onChange={handleSubjectChange}
        />
        <TextField
          label="TRN"
          value={customerTRN}
          size="small"
          variant="standard"
          onChange={handleTRNChange}
        /> */}

      </div>

      <div className="flex justify-between items-center gap-4">

        {/* commented , because to identify where will be the effect of this edit ie address will it reflect in main customer data , because in quoation pdf nowhere is used*/}
        {/* <TextField
          label="Organization Address"
          value={
            [
              selectedLead?.lead_streetaddress,
              selectedLead?.lead_territory,
              selectedLead?.lead_country,
              selectedLead?.lead_city,
              selectedLead?.lead_appartment,
              selectedLead?.lead_area,
              selectedLead?.lead_location,
            ]
              .filter((field) => field && field.trim() !== "")
              .join(", ") || "New Address"
          }
          size="x-large"
          fullWidth
          multiline
          variant="standard"
          InputProps={{
            style: { fontSize: "1rem" },
          }}
        /> */}

        {/* commented by jinu clarify what to do then make visible */}
        {/* <div className="flex justify-center items-center gap-6">
          <RelatedDocs />
          <QuotationDocs />
        </div> */}
      </div>
    </div>
  );
};

export default CustomerDetailsTab;
